import React from "react";
import GA4React from "ga-4-react";
import ReactDOM from "react-dom";
import App from "./components/app";
import { Provider } from "react-redux";
import { store } from "./app/store";
import OnlineStatusProvider from "./providers/onlineStatusProvider";
import TagManager from "react-gtm-module";

const ga4react = new GA4React("G-33RJQ4JGTD");

const tagManagerArgs = {
  gtmId: "GTM-MJRDMZZ",
};

// Initialize GTM
TagManager.initialize(tagManagerArgs);

// Initialize GA4
ga4react
  .initialize({ timeout: 10000 })
  .then(() => {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <OnlineStatusProvider>
            <App />
          </OnlineStatusProvider>
        </Provider>
      </React.StrictMode>,
      document.getElementById("root")
    );
  })
  .catch((err) => {
    console.log("GA4React initialization error:", err);
  });
